<!--
@Create By Tim For 19/08/16
@课件目录组件
-->
<template>
  <div class="CourseCatalog">
    <div class="CourseCatalogList" v-for="(item, key) in chapterList" :key="key">
      <!-- 课程标题 -->
      <p class="CourseCatalogListTitle">{{ item.chapterName }}</p>
      <!-- 课程章节 -->
      <div class="CourseCatalogListInfo" v-for="(list, index) in item.children" :key="index">
        <i class="el-icon-video-play" @click="playerVideo(list)"></i>
        {{ list.chapterName }}
        <span>（{{ list.videoTimeLength }}）</span>
      </div>
    </div>

    <!-- 视频播放组件 -->
    <!-- <VideoPlayer ref="videoPlayer" /> -->
  </div>
</template>

<script>
import api from '../../../config/api';
import Bus from '../../bus';
//import VideoPlayer from '../VideoPlayer';

export default {
  name: 'CourseCatalog',
  components: {
   // VideoPlayer
  },
  props: ['chapterList'],
  data() {
    return {
    };
  },
  methods: {
    // 视频播放
    playerVideo(row) {
      if (row.m3u8Url) {
        // 当前播放数据
        this.$emit('select', row);
        // 调用视频播放弹窗内的打开弹窗方法
        //this.$refs.videoPlayer.openVideoDialog(row.m3u8Url, row.chapterName);
      }
    }
  }
};
</script>

<style scoped>
.CourseCatalog {
  padding: 0 20px 20px 20px;
  background: #fff;
}

.CourseCatalog .CourseCatalogList {
  margin-bottom: 50px;
}

.CourseCatalogListTitle {
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}

.CourseCatalog .CourseCatalogListInfo {
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  background: #f4f4f4;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  margin-bottom: 15px;
}

.CourseCatalog .CourseCatalogListInfo span {
  font-size: 14px;
  color: #999;
}

.CourseCatalog .CourseCatalogListInfo i {
  color: #93dbff;
  font-size: 22px;
  vertical-align: sub;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseInfo/CourseCatalog.vue